import { defa } from 'defa-object';
import ClusterModel    from 'scripts/poppet/cluster-model';

/**
 * defa.models.MasterControl
 * The DEFA MasterControl model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	warmup: '/homeAutomation/masterControl?attrs=',
};

const MasterControl = ClusterModel.extend( {
	url: function() {
		return api.linkcom + this.get('id') + api.warmup + this.getAttributes();
	},
	
	onError: function (model, response, options) {
		let models = this._getModels();
		for (let index in models ) {
			models[index].trigger('error', model, response, options);
		}
	},
	_getModels: function() {
		let id = this.get('id');
		return [
			channel.request('heatingSwitchs').get(id),
			channel.request('alarmSwitchs').get(id),
			channel.request('calendars').get(id),
			channel.request('temperatureAlerts').get(id),
			channel.request('dayAndNightSettings').get(id),
		];
	},
	
});

export default MasterControl;
